import { createFileRoute, redirect } from '@tanstack/react-router'
import { invoiceQuery } from '@/features/accounting-invoices/api'
import { InvoiceFormScreen } from '@/features/accounting-invoices/invoice-form-screen'
import { hasGrant, type Me, meQuery } from '@/lib/me'

/**
 * Route shell for editing a DRAFT invoice.
 *
 * The API refuses a PATCH on anything but a draft (UpdateDraftInvoice throws
 * and the endpoint answers 422). Load the record before rendering so a direct
 * URL cannot expose an editable form for a confirmed document.
 */
export const Route = createFileRoute('/_authenticated/accounting/invoices/$invoiceId/edit')({
  beforeLoad: async ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'accounting_invoice.edit')) {
      throw redirect({
        to: '/accounting/invoices/$invoiceId',
        params: { invoiceId: params.invoiceId },
      })
    }

    const me = context.queryClient.getQueryData<Me>(meQuery.queryKey)
    const invoice = await context.queryClient.ensureQueryData(
      invoiceQuery(me?.active_company_id ?? null, params.invoiceId),
    )

    if (invoice?.status !== 'draft') {
      throw redirect({
        to: '/accounting/invoices/$invoiceId',
        params: { invoiceId: params.invoiceId },
      })
    }
  },
  component: AccountingInvoiceEditRoute,
})

function AccountingInvoiceEditRoute() {
  const { invoiceId } = Route.useParams()

  return <InvoiceFormScreen invoiceId={invoiceId} />
}
